export default {
  navigation: state => state.navigation,
  navigationServices: state => state.navigationServices
};